'use client';

import Reveal from './Reveal';

export default function Story() {
  return (
    <section className="max-w-7xl mx-auto px-6 py-16">
      <Reveal>
        <h2 className="text-2xl sm:text-3xl font-bold text-gray-900">「これってどうなの？」そのモヤモヤ、放置しないで。</h2>
      </Reveal>
      <Reveal className="mt-4">
        <p className="text-gray-800 text-lg max-w-3xl">
          税理士にわざわざ聞くほどではないけれど、ネットで調べても自分のケースの正解がわからない…。そんな「ちょっとした疑問」が、あなたの決断を遅らせていませんか？TaxMCPなら、まるで専属の専門家が隣にいるような感覚で、いつでも気軽に相談可能。日々の迷いを確信に変え、本来のビジネスに集中できる環境を手に入れてください。
        </p>
      </Reveal>
    </section>
  );
}
